<template>
    <v-card class="mx-auto card-box-bg" max-width="400" outlined>
        <img :src="properties.imageURL" class="img-box" alt="logo">
        <v-card-text>
            <v-layout row>
                <v-flex md6 class="v-title"> {{ properties.borrow }}:</v-flex>
                <v-flex md6 class="v-des"> {{ properties.value_borrow }} </v-flex>
            </v-layout>
            <v-divider :inset="inset"></v-divider>

            <v-layout row>
                <v-flex md6 class="v-title"> {{ properties.repay }}:</v-flex>
                <v-flex md6 class="v-des"> {{ properties.value_repay }}</v-flex>
            </v-layout>
            <v-divider :inset="inset"></v-divider>

            <v-layout row>
                <v-flex md6 class="v-title"> {{ properties.initiation_fee }}:</v-flex>
                <v-flex md6 class="v-des"> {{ properties.value_initiation_fee }} </v-flex>
            </v-layout>
            <v-divider :inset="inset"></v-divider>

            <v-layout row>
                <v-flex md6 class="v-title">{{ properties.monthly_service_fee }}:</v-flex>
                <v-flex md6 class="v-des"> {{ properties.value_monthly_service_fee }} </v-flex>
            </v-layout>
            <v-divider :inset="inset"></v-divider>

        </v-card-text>

        <v-card-actions>
            <v-layout row xs12>
                <v-btn :disabled="submitted" @click="callJumpStartNow" v-if="properties.show_call_back" block class="no-text-transform action-btn">
                    Call Me Back
                </v-btn>
                <v-btn block outline v-if="properties.show_apply_online_button" class="no-text-transform border-btn action-btn" @click="trackLeadSubmit" :href="properties.url" target="_blank">
                    Apply Online
                </v-btn>
            </v-layout>
        </v-card-actions>
    </v-card>
</template>

<script>
  export default {
    name: 'CardInfo',
    props: {
      properties: {
        type: Object
      }
    },
    data: () => ({
      flat: false,
      media: true,
      loading: false,
      actions: true,
      outlined: true,
      elevation: undefined,
      raised: false,
      inset: false,
      submitted: false

    }),
    methods: {
      trackLeadSubmit() {
        this.$mixpanel.track('Lead Submitted', {
          LeadProvider: this.properties.lead_provider,
          SubmissionType: 'Web'
        })
      },
      callJumpStartNow() {
        this.$http.get(this.jumpStartUrlNow)
        this.$mixpanel.track('Lead Submitted', {
          LeadProvider: this.properties.lead_provider,
          SubmissionType: 'Call Back'
        })
        this.submitted = true
      }
    },
    computed: {
      jumpStartUrlNow() {
        if (process.env.NODE_ENV === 'development') {
          return true
        }

        return `https://capitec.jumpstartcom.co.za/jumpstart.forms/internalapps/shortcode_incoming.aspx?CFCode=161&Phonenumber=${this.$store.state.cell}&PARAM1=${this.$store.state.firstName}&Surname=${this.$store.state.surname}&IDNumber=${this.$store.state.ID}&CoName=&IncomingData=1&CC=4125&JS=Y`
      }
    }
  }
</script>

<style scoped>

    .card-box-bg {
        margin: 15px;
        padding: 15px;
        background-color: #FFFFFF;
        box-shadow: 0 9px 35px 7px rgba(0,0,0,0.1);
        border-radius: 10px;
    }

    .img-box {
        margin-top: -60px;
        max-width: 50%;
    }

    .border-btn {
        border:3px solid;
    }

    .v-title {
        color: #77787B;
        font-size: 1.1rem;
        line-height: 3.5rem;
        text-align: left;
        font-family: 'Montserrat', 'Arial', sans-serif !important;
    }

    .v-des {
        color: #77787B;
        font-size: 1.1rem;
        line-height: 3.5rem;
        font-weight: bold;
        text-align: right;
        font-family: 'Montserrat', 'Arial', sans-serif !important;
    }

    .action-btn {
        font-size: 14px;
        font-weight: bold;
    }

    .action-btn a{
        color: #3ed29f;
    }
</style>
